/* Source collections.js reveal timing; commerce stays with Shopify facets.js.
   Do not import prototype product arrays, URL filters, palette or cart events. */
(() => {
  if (window.hanCollectionSourceLoaded) return;
  window.hanCollectionSourceLoaded = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const bound = new WeakSet();
  const reveal = typeof IntersectionObserver === 'undefined' ? null : new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      reveal.unobserve(entry.target);

    });
  }, {threshold:.04});
  function initialise(scope = document) {
    scope.querySelectorAll('.han-collection-source [data-collection-reveal]').forEach(element => {
      if (seen.has(element)) return;
      seen.add(element); reveal?.observe(element);
    });
    scope.querySelectorAll('.han-collection-source .facets__container--horizontal').forEach(container => {
      if (bound.has(container)) return;
      bound.add(container);
      const form = container.closest('form');
      const trigger = form?.querySelector('.facets__button-show');
      const panel = container.querySelector('.facets__wrapper');
      const getClose = () => container.querySelector('.facets-modal__close');
      if (!trigger || !panel || !getClose()) return;
      trigger.setAttribute('aria-haspopup','dialog');
      if (panel.id) trigger.setAttribute('aria-controls',panel.id);
      panel.setAttribute('role','dialog');panel.setAttribute('aria-modal','true');
      const label = panel.querySelector('.facets-modal__heading');
      if (label) panel.setAttribute('aria-label',label.textContent.trim());
      const show = document.createElement('button');
      show.type = 'button';
      show.className = 'han-filter-show';
      show.innerHTML = '<span></span><svg viewBox="0 0 24 12" width="22" height="12" fill="none" stroke="currentColor" aria-hidden="true"><path d="M1 6h21m-5-5 5 5-5 5"/></svg>';
      panel.append(show);
      show.addEventListener('click', () => getClose()?.click());
      const updateCount = () => {
        const count = panel.querySelector('#ProductCount')?.textContent.replace(/[^0-9]/g, '') || '0';
        const text = `Show ${count} ${count === '1' ? 'Product' : 'Products'}`;
        if (show.firstElementChild.textContent !== text) show.firstElementChild.textContent = text;
      };
      updateCount();
      const countObserver = new MutationObserver(updateCount);
      countObserver.observe(panel, {childList:true, subtree:true, characterData:true});
      let wasOpen = false;
      let motion;
      const sync = () => {
        const open = container.classList.contains('active');
        trigger.setAttribute('aria-expanded',String(open));
        panel.inert = !open;
        if (open !== wasOpen) {
          motion?.cancel();
          if (!reduced.matches) motion = panel.animate(open
            ? [{transform:'translateX(35px)',opacity:0},{transform:'translateX(0)',opacity:1}]
            : [{transform:'translateX(0)',opacity:1},{transform:'translateX(25px)',opacity:0}],
            {duration:open ? 380 : 200,easing:'cubic-bezier(.16,1,.3,1)'});
          if (open) getClose()?.focus({preventScroll:true});
          else trigger.focus({preventScroll:true});
        }
        wasOpen = open;
      };
      sync();
      const observer = new MutationObserver(sync);
      observer.observe(container,{attributes:true,attributeFilter:['class']});
      panel.addEventListener('keydown',event => {
        if (event.key === 'Escape' && container.classList.contains('active')) {
          event.preventDefault();getClose()?.click();
        }
        if (event.key !== 'Tab' || !container.classList.contains('active')) return;
        const focusable = Array.from(panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),summary,[tabindex="0"]')).filter(element => element.getClientRects().length);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {event.preventDefault();last?.focus();}
        else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first?.focus();}
      });
      const section = container.closest('.shopify-section');
      section?.addEventListener('shopify:section:unload',() => { observer.disconnect(); countObserver.disconnect(); },{once:true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => initialise(),{once:true});
  else initialise();
  document.addEventListener('shopify:section:load',event => initialise(event.target));
})();
